<template>
    <main class="main restaurant" id="main">
        <navigate></navigate>
        <section class="section s-lk">
            <div class="container">
                <div class="lk_restaurant_form">
                    <div class="form_header">
                        <nav class="nav_box">
                            <ul class="nav_inner_box">
                                <li :class="page === 'RIndex' ? 'link active': 'link'" @click="page = 'RIndex'">Ресторан</li>
                                <li :class="page === 'RZones' ? 'link active': 'link'" @click="page = 'RZones'">Зоны доставки</li>
                                <li :class="page === 'RMenu' ? 'link active': 'link'" @click="page = 'RMenu'">Меню</li>
                                <li :class="page === 'RStocks' ? 'link active': 'link'" @click="page = 'RStocks'">Акции</li>
                                <li :class="page === 'RDops' ? 'link active': 'link'" @click="page = 'RDops'">Дополнительные пользователи</li>
                                <li :class="page === 'RComments' ? 'link active': 'link'" @click="page = 'RComments'">Комментарии</li>
                                <!--li class="link" @click="deleteRestaurant()">Удалить ресторан</li-->
                                <li :class="page === 'RCopy' ? 'link active': 'link'" @click="page = 'RCopy'">Скопировать ресторан</li>
                            </ul>
                        </nav>
                    </div>
                    <r-index v-if="page === 'RIndex'" :id.sync="id" :auth.sync="auth" :user.sync="user" :mapinit.sync="mapinit"></r-index>
                    <r-zones v-if="page === 'RZones'" :id.sync="id" :auth.sync="auth" :user.sync="user" :mapinit.sync="mapinit"></r-zones>
                    <r-menu v-if="page === 'RMenu'" :id.sync="id" :auth.sync="auth" :user.sync="user"></r-menu>
                    <r-stocks v-if="page === 'RStocks'" :id.sync="id" :auth.sync="auth" :user.sync="user"></r-stocks>
                    <r-dops v-if="page === 'RDops'" :id.sync="id" :auth.sync="auth" :user.sync="user"></r-dops>
                    <r-comments v-if="page === 'RComments'" :id.sync="id" :auth.sync="auth" :user.sync="user"></r-comments>
                    <r-copy v-if="page === 'RCopy'" :id.sync="id" :auth.sync="auth" :user.sync="user"></r-copy>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
import axios from '@/router/http'
import Navigate from '@/pages/lk/user/navigate'
import RIndex from '@/pages/lk/user/restaurant/index'
import RZones from '@/pages/lk/user/restaurant/zones'
import RMenu from '@/pages/lk/user/restaurant/menu'
import RStocks from '@/pages/lk/user/restaurant/stocks'
import RDops from '@/pages/lk/user/restaurant/dops'
import RCopy from '@/pages/lk/user/restaurant/copy'
import RComments from '@/pages/lk/user/restaurant/comments'
export default {
  name: 'restaurant',
  components: {Navigate, RIndex, RZones, RMenu, RStocks, RDops, RCopy, RComments},
  props: ['city', 'auth', 'mapinit', 'basket', 'geo', 'user'],
  data () {
    return {
      page: 'RIndex',
      id: null
    }
  },
  created () {
    this.id = this.$route.params.id
  },
  methods: {
    deleteRestaurant () {
      if (confirm('Вы точно хотите удалить ресторан?')) {
        if (confirm('Ведь это действие будет сложно обратить, удаляем?')) {
          var formData = new FormData()
          formData.append('id', this.id)
          formData.append('uid', this.$root.auth.uid)
          axios.post('https://lk.when-hungry.com/mobile/delete-restaurant',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(() => {
            this.$router.push({name: 'restaurants'})
            setTimeout(() => {
              alert('Рестаран удален')
            }, 1)
          })
        }
      }
    }
  },
  watch: {
    $route (to, from) {
      this.id = to.params.id
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/user/restaurant.vue